import "../chunk-XTU7I5IS.js";
import { createContextAndHook } from "@clerk/shared/react";
const [AuthContext, useAuthContext] = createContextAndHook("AuthContext");
export {
  AuthContext,
  useAuthContext
};
//# sourceMappingURL=AuthContext.js.map